import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from 'echarts';
export default {
  props: {
    vData: {
      type: Object,
      default: function _default() {
        return {
          data: [],
          data2: [],
          title: ''
        };
      }
    }
  },
  watch: {
    'vData.data': {
      handler: function handler() {
        var _this = this;
        this.$nextTick(function () {
          _this.initChart1();
          _this.initChart2();
        });
      },
      deep: true
    }
  },
  data: function data() {
    return {
      option: null,
      dataMap: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    initChart1: function initChart1() {
      // 实例化对象
      var myChart = echarts.init(document.getElementById('chart_left2'));
      var scaleData = this.vData.data || [];
      var rich = {
        white: {
          color: '#ddd',
          align: 'center',
          padding: [0, 0]
        }
      };
      var placeHolderStyle = {
        normal: {
          label: {
            show: true
          },
          labelLine: {
            show: false
          },
          color: 'rgba(0, 0, 0, 0)',
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 0
        }
      };
      var data = [];
      var color = ['#ff004d', '#006ced', '#ffe000', '#f3ba82', '#ffa800', '#ff5b00', '#ff3000'];
      for (var i = 0; i < scaleData.length; i++) {
        data.push({
          value: scaleData[i].ct,
          name: scaleData[i].name || '未知',
          itemStyle: {
            normal: {
              borderWidth: 22,
              shadowBlur: 2,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        }, {
          value: 0,
          name: '',
          itemStyle: placeHolderStyle
        });
      }
      var option = {
        color: color,
        tooltip: {
          trigger: 'item'
        },
        series: [{
          name: '',
          type: 'pie',
          clockWise: false,
          radius: ['50%', '50%'],
          center: ['50%', '50%'],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'outside',
                color: '#ddd',
                formatter: function formatter(params) {
                  var percent = 0;
                  var total = 0;
                  for (var _i = 0; _i < scaleData.length; _i++) {
                    total += scaleData[_i].ct;
                  }
                  percent = (params.value / total * 100).toFixed(0);
                  if (params.name !== '') {
                    return params.name + '\n{white|' + '占比' + percent + '%}';
                  } else {
                    return '';
                  }
                },
                rich: rich
              },
              labelLine: {
                length: 10,
                length2: 30,
                show: true,
                color: '#e6a245'
              }
            }
          },
          data: data
        }]
      };
      myChart.setOption(option, true);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    initChart2: function initChart2() {
      // 实例化对象
      var myChart = echarts.init(document.getElementById('chart_right2'));
      var charts = {
        // 按顺序排列从大到小
        nameList: [],
        dataList: []
      };
      if (this.vData.data2) {
        this.vData.data2.map(function (item) {
          charts.nameList.push(item.name || "未知");
          charts.dataList.push(item.ct);
        });
      }
      var top10nameList = charts.nameList;
      var top10dataList = charts.dataList;
      var lineY = [];
      for (var i = 0; i < charts.nameList.length; i++) {
        var data = {
          name: charts.nameList[i],
          color: '#e6a245',
          value: top10dataList[i],
          itemStyle: {
            normal: {
              show: true,
              color: '#e6a245',
              barBorderRadius: 10
            },
            emphasis: {
              shadowBlur: 15,
              shadowColor: 'rgba(0, 0, 0, 0.1)'
            }
          }
        };
        lineY.push(data);
      }

      // 指定配置和数据
      var option = {
        // title: {
        //   text:this.vData.subtitle2,
        // },
        dataZoom: [{
          type: "slider",
          //滑动条
          show: charts.dataList.length > 10,
          //开启
          yAxisIndex: [0],
          left: "96%" //滑动条位置
        }, {
          type: "inside",
          //内置滑动，随鼠标滚轮展示
          yAxisIndex: [0]
        }],
        tooltip: {
          trigger: 'item'
        },
        grid: {
          borderWidth: 0,
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        yAxis: [{
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            inside: false,
            textStyle: {
              color: '#b3ccf8',
              fontSize: 13
            }
          },
          data: top10nameList
        }, {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            inside: false,
            textStyle: {
              color: '#b3ccf8',
              fontSize: 13
            },
            formatter: function formatter(value) {
              var texts = value;
              if (texts.length > 10) {
                texts = texts.substr(0, 10) + '...';
              }
              return texts;
            }
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          data: top10dataList.reverse()
        }],
        series: [{
          name: '',
          type: 'bar',
          zlevel: 2,
          barWidth: '10px',
          data: lineY,
          animationDuration: 1500,
          label: {
            normal: {
              color: '#b3ccf8',
              show: false,
              position: [0, '-15px'],
              textStyle: {
                fontSize: 13
              },
              formatter: function formatter(a, b) {
                return a.name;
              }
            }
          }
        }]
      };

      // 把配置给实例对象
      myChart.setOption(option, true);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {}
};